import React, { useEffect } from "react";
import { motion } from "framer-motion";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact — Viktoriia Yashkina";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
      className="body"
    >
      <div className="containerBody">
        <div className="contextContainer">
          <h2 className="h2">get in touch</h2>
          <div>
            <div className="textContainer">
              <p>Thank you for stopping by.</p>
              <p>
                I am looking for a job. I am open to any suggestions and am
                always ready to discuss them. Whether it is the internship or
                the entry-level position.
              </p>
              <p>Feel free to get in touch and say hi.</p>
              <p className="pt-10">
                Email:{" "}
                <a
                  href="mailto:yashkina.viktoriia@proton.me"
                  className="allLinks  text-[16px]"
                >
                  yashkina.viktoriia@proton.me
                </a>
              </p>
              <p>
                LinkedIn:{" "}
                <a
                  href="https://www.linkedin.com/in/viktoriia-yashkina/"
                  rel="noreferrer"
                  target="_blank"
                  className="allLinks text-[16px]"
                >
                  LinkedIn
                </a>
              </p>
              <p>Lication:</p>
              <p>Kyiv, Ukraine</p>
              <p>Ready to work in office or remote.</p>
              <p>Guardini Naxos, Italy.</p>
              <p>Work remotely</p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Contact;
